import React, { Component, Fragment } from "react";
import "./index.sass";

export default class ErrorBoundary extends Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error(error, errorInfo);
		console.debug("Component Stack Error", error);
		console.debug("Component Stack errorInfo", errorInfo);
	}

	renderBody() {
		return <div></div>;
	}

	render() {
		if (this.state.hasError) {
			// You can render any custom fallback UI
			return (
				<div className="error-wrapper">
					<h1>Oppsss!</h1>
					<h2>Something went wrong</h2>
					<h3>Please refresh page</h3>
				</div>
			);
		}

		if (this.props.isFunctional) {
			return <Fragment>{this.props.children}</Fragment>;
		}

		return this.renderBody();
	}
}
